import {Inject, Injectable} from '@angular/core';
import * as _ from 'lodash';

import {
    ControlData,
    MenuElement, MenuElementType100, MenuElementType12, MenuElementType13,
    OnOffScheduleValue,
    ScheduleMulti, SchedulePlusMinusData,
    ScheduleRange
} from "../../models";
import {ControlService} from "./control.service";
import {DOCUMENT} from "@angular/common";
import {SendDataService} from "../send-data.service";
import {ParametersService} from "../parameters.service";
import {BehaviorSubject} from "rxjs";
import {AppAlertService} from "../app-alert.service";
import {SubtitlesService} from "../subtitles.service";

@Injectable({
    providedIn: 'root'
})
export class ScheduleService {
    bgActive: boolean = false;
    private isMoving: boolean = false;
    multiTable: ScheduleMulti[] = [];
    multTableChanged = new BehaviorSubject(false);
    multiTableChanged$ = this.multTableChanged.asObservable();
    scheduleMin: number = 0;
    scheduleMax: number = 0;
    scheduleTable: number[] = [];
    private startValOnOff: boolean = false;
    onOffTable: OnOffScheduleValue[] = [];
    private tempDelta: number = 0;
    private temp: number[] = [];
    tempRange: boolean = false;
    tempSet: number = -1;
    private tmpBrotherElement: MenuElement[] | false | number;
    private tmpOnOffTable: OnOffScheduleValue[] = [];
    private touchedIndices: number[] = [];
    constructor(
        @Inject(DOCUMENT) private document: Document,
        private control: ControlService,
        private parameters: ParametersService,
        private sendData: SendDataService,
        private appAlert: AppAlertService,
        private subtitles:SubtitlesService,
    ) {
    }

    showHideBg(): void {
        this.clearMultiTempRange();
        this.tempSet = -1;

        if (this.tempRange === false) {
            this.bgActive = !this.bgActive;
        }
    }

    onOffToggleHourByIndex(index: number): void {
        if (!this.isMoving || index <= 0) return;
        if (this.touchedIndices.includes(index)) return;

        this.onOffTable[index].val = !this.startValOnOff;
        this.touchedIndices.push(index);
    }

    onOffEndDrag(): void {
        this.isMoving = false;
        this.startValOnOff = false;
        this.touchedIndices = [];
    }
    closeInnerModal(): void {
        this.multiTable.forEach(element => {
            element.isVisible = false;
        });
        this.tempRange = false;
        this.showHideBg()
    }

    private checkBrotherElement(): void {
        if (this.control.brotherElement && Array.isArray(this.control.brotherElement)) {
            this.control.brotherElement.forEach(val => {
                val.checked = val.id === this.control.elementVal.getValue().id;
            })
        } else {
            this.control.brotherElement = [];
        }
    }

    // ==== Plus Minus schedule

    setScheduleTable(typeSettings?: 'default' ): void {
        this.checkBrotherElement();

        if (this.control.setTemp !== 0) {
            this.scheduleMin = parseInt(this.control.setTemp.params['value'])
                + this.control.elementVal.getValue().params['min'];
            this.scheduleMax = parseInt(this.control.setTemp.params['value'])
                + this.control.elementVal.getValue().params['max'];
        }

        const table: number[] =[];

        const elementVal = this.control.elementVal.getValue() as MenuElementType12;
        if (elementVal.params.values.length > 0 && typeSettings !== 'default') {
            for (let i = 0; i < 24; i++) {
                if(elementVal.params.values[i] !== undefined){
                    table[i] = elementVal.params.values[i] + this.scheduleMin;
                } else {
                    if (this.control.setTemp !== 0) {
                        table[i] = this.control.setTemp.params['value'];
                    }
                }
            }
        } else {
            for (let i = 0; i < 24; i++) {
                if (this.control.setTemp !== 0) {
                    table[i] = this.control.setTemp.params['value'];
                }
            }
        }

        this.scheduleTable = table;
    }

    returnScheduleTable(): void {
        if (!this.control.brotherElement) {
            this.control.brotherElement = this.control.elementVal.getValue().id;
        }

        const scheduleData: SchedulePlusMinusData[] = [];
        const table = this.scheduleTable.slice();
        this.tmpBrotherElement = _.cloneDeep(this.control.brotherElement);

        this.scheduleTable.forEach((val,key) => {
            table[key] = val - this.scheduleMin;
        });

        if (Array.isArray(this.control.brotherElement) && this.control.brotherElement.length) {
            let count = 0;
            for (const element of this.control.brotherElement as MenuElementType12[]) {
                if(element.checked) {
                    element.params.values = table;
                    element.duringChange = 't';

                    scheduleData[count] = {
                        ido: element.id,
                        table,
                        menuType: element.menuType
                    };

                    count++;
                }
            }
        } else {
            scheduleData.push({
                ido: this.control.elementVal.getValue().id,
                table,
                menuType: this.control.elementVal.getValue().menuType
            });
        }

        scheduleData.forEach(({ menuType, ido, table }) => {
            const dataToSend: ControlData = {
                menuType,
                ido,
                data: {
                    weekly_plus_minus: {
                        values: table
                    }
                }
            }
            if (this.control.pin) {
                dataToSend.data.pin = this.control.pin
            }
            this.sendData.sendControlData(dataToSend);
        })

        if (this.control.pin) {
            this.control.pin = ''
        }

        if (!this.parameters.demoAccount()) {
            const element = this.control.element.getValue() as MenuElementType12;
            element.params.values = table;
            element.duringChange = 't';
            this.control.element.next(element);
            this.control.setsNewValue = this.control.elementVal.getValue().id;
            this.control.hideControl();
        } else {
            if (Array.isArray(this.control.brotherElement)) {
                this.control.brotherElement.forEach((val, key) => {
                    val.params = this.tmpBrotherElement[key].params;
                    val.duringChange = this.tmpBrotherElement[key].duringChange;
                });
            }
        }
    }

    // ==== onOff schedule

    onOffGetSet(type: 'main' | 'default'): void {
        const elementVal = this.control.elementVal.getValue() as MenuElementType13;
        if( type === 'default') {
            this.setOnOff(elementVal.params.default);
        } else {
            this.setOnOff(elementVal.params.value);
        }
        this.checkBrotherElement();
    }

    setOnOff(value: number): void {
        let zoneNumber = 0;
        let j = 0;
        let zoneSize = 0;
        const onOffTable: OnOffScheduleValue[] = [];

        let selectElement = value.toString(2);
        selectElement = selectElement.split("").reverse().join("");
        selectElement = '0'+selectElement;

        const elementVal = this.control.elementVal.getValue() as MenuElementType13;
        if (elementVal.params.noZones === 24) {
            zoneNumber = 24;
            zoneSize = 1;
        } else {
            zoneNumber = 48;
            zoneSize = 0.5;
        }

        for (let i = 0; i <= zoneNumber; i++) {
            onOffTable[i] = {
                id: i,
                val: selectElement[i] === '1',
                hour: 0,
            };

            if (j%1 === 0) {
                onOffTable[i].hour = j;
            } else {
                onOffTable[i].hour = '';
            }

            j = j + zoneSize;
        }

        this.onOffTable = onOffTable;
    }

    onOffSetStartVal(val: boolean): void {
        this.isMoving = true;
        this.startValOnOff = val;
        this.onOffResetStartVal();
    }

    onOffResetStartVal() {
        this.temp = [];
    }

    onOffToggleHour(event: TouchEvent | MouseEvent, actionType: 'move' | 'end'): void {
        if (!this.isMoving) return;

        const allElements = this.document.querySelectorAll(".on-off__select-hour-inside") as NodeListOf<HTMLDivElement>;
        const scroll = document.querySelector("#scrollSet").scrollLeft;
        let positionX = 0;
        let scrollPos = 0;
        const div = allElements[1];
        const rect = div.getBoundingClientRect();

        if (event instanceof MouseEvent) {
            positionX = event.clientX - rect.x + div.offsetLeft;
        } else {
            if (event.type === 'touchend' || event.type === 'touchcancel') {
                positionX = event.changedTouches[0].clientX  - rect.x + div.offsetLeft;
            }
            if (event.type === 'touchmove') {
                positionX = event.touches[0].clientX  - rect.x + div.offsetLeft;
            }
            scrollPos = scroll;
            event.stopImmediatePropagation();
            event.preventDefault();
        }

        positionX = positionX + scrollPos;

        allElements.forEach((val, key) => {
            if (!(positionX <= val.offsetLeft || positionX >= val.offsetLeft + val.clientWidth )) {
                if (this.temp.indexOf(key) < 0 ) {
                    this.temp.push(key);
                    this.onOffTable[key].val = this.startValOnOff !== true;
                }
            }
        });

        if (actionType === 'end') {
            this.isMoving = false;
            this.startValOnOff = false;
            this.onOffResetStartVal();
        }
    }

    returnOnOffTable(): void {
        let count = 0;
        let data = '';
        let table = [];
        const scheduleData = [];

        if (!this.control.brotherElement || (Array.isArray(this.control.brotherElement) && this.control.brotherElement.length == 0) ) {
            this.control.brotherElement = this.control.elementVal.getValue().id;
        }

        this.tmpBrotherElement = _.cloneDeep(this.control.brotherElement);
        this.tmpOnOffTable = _.cloneDeep(this.onOffTable);
        this.tmpOnOffTable.shift();

        this.tmpOnOffTable.forEach((val) => {
            data += val.val ? "1" : "0";
            table.push(val.val ? 1 : 0);
        });

        data = parseInt(data.split('').reverse().join(''), 2).toString();

        if (Array.isArray(this.control.brotherElement)) {
            this.control.brotherElement.forEach((val, key) => {
                if(val.checked) {
                    this.control.brotherElement[key].params.value = data;
                    this.control.brotherElement[key].duringChange = 't';

                    scheduleData[count] = {
                        ido: val.id,
                        table,
                        menuType: this.control.brotherElement[key].menuType
                    };
                    count++;
                }
            });
        } else {
            scheduleData[0] = {
                ido: this.control.elementVal.getValue().id,
                table,
                menuType: this.control.elementVal.getValue().menuType,
            };
        }

        scheduleData.forEach(({ menuType, ido, table }) => {
            const dataToSend = {
                menuType,
                ido,
                data: {
                    weekly_on_off: {
                        values: table,
                    }
                }
            }
            if (this.control.pin) {
                dataToSend.data['pin'] = this.control.pin;
            }

            this.sendData.sendControlData(dataToSend);
        })

        if (this.control.pin) {
            this.control.pin = ''
        }

        if (!this.parameters.demoAccount()) {
            const element = this.control.element.getValue() as MenuElementType13;
            element.params.value = parseInt(data, 10);
            element.duringChange = 't';
            this.control.element.next(element);

            this.control.setsNewValue = this.control.elementVal.getValue().id;
            this.control.hideControl();
        } else {
            if (Array.isArray(this.control.brotherElement)) {
                (this.control.brotherElement as MenuElementType13[]).forEach((val, key) => {
                    val.params.value = this.tmpBrotherElement[key].params.value;
                    val.duringChange = this.tmpBrotherElement[key].duringChange;
                });
            }
        }
    }

    // ==== Multi schedule

    private checkScheduleIntervals(): void {
        const multiTable = _.cloneDeep(this.multiTable);

        for (let index = 0; index < multiTable.length; index++) {
            if (index === 0 && multiTable[index].startTime === multiTable[index].endTime) {
                multiTable[index].endTime += 15;
            }

            if (index > 0 && multiTable[index].startTime <= multiTable[index - 1].endTime) {
                multiTable[index].startTime = multiTable[index - 1].endTime;
            }

            if (index > 0 && multiTable[index].endTime <= multiTable[index].startTime) {
                multiTable[index].endTime = multiTable[index].startTime + 15;
            }
        }

        const elementVal = this.control.elementVal.getValue() as MenuElementType100;
        if (elementVal.params.type === 0) {
            if (multiTable[multiTable.length - 1].endTime !== 1439) {
                multiTable[multiTable.length - 1].endTime = 1439;
            }
            if (multiTable[0].startTime !== 0) {
                multiTable[0].startTime = 0;
            }
        }

        this.multiTable = multiTable;
    }

    getMultiTable(): void {
        this.checkBrotherElement();
        this.tempRange = false;
        const elementVal = this.control.elementVal.getValue() as MenuElementType100;
        this.multiTable = elementVal.params.rows;
        this.checkScheduleIntervals();
    }

    getAdjacentIntervals(min: number, max: number, index: number, position: 'start' | 'end'): void {
        if (index === 0 && position === 'start') return;
        if (index === this.multiTable.length -1 && position === 'end') return;

        const multiTable = _.cloneDeep(this.multiTable);
        let count = 0;

        if ((window.innerWidth <= 960) && (min >= 0 && max >= 0)) {
            this.showHideBg();

            if (index >= 0) multiTable[index].position = position;

            for (const element of multiTable) {
                element.range = [];
            }

            multiTable[index].active = 0;
            min = this.quarterTime(min) + 15;
            max = this.quarterTime(max) - 15;
            multiTable[index].range.push(min);

            if (min == multiTable[index].startTime || min == multiTable[index].endTime) multiTable[index].active = min;

            for (let i = min; i <= max; i++) {
                if (multiTable[index].range[count] !== (this.quarterTime(i))) {
                    multiTable[index].range.push(i);

                    if (multiTable[index].position == 'start') {
                        if (this.quarterTime(multiTable[index].startTime) == i) {
                            multiTable[index].active = i;
                        }
                    } else {
                        if (this.quarterTime(multiTable[index].endTime) == i) {
                            multiTable[index].active = i;
                        }
                    }
                    count++;
                }
            }
            this.multiTable = multiTable;
            this.setScroll(index);
        }
    }

    getNonAdjacentIntervals(min: number, max: number, index: number, position: 'start' | 'end', type: number): void {
        const multiTable = _.cloneDeep(this.multiTable);
        let count = 0;

        if (type == 28) {
            if (index === 0 && position === 'start') {
                min = 0;
                max = multiTable[index].endTime - 15;
            } else if (index >= 1 && position == 'start') {
                min = multiTable[index - 1].endTime;
                max = multiTable[index].endTime - 15;
            } else if (index == multiTable.length - 1 && position == 'end') {
                min = multiTable[index].startTime + 15;
                max = 1439;
            } else {
                min = multiTable[index].startTime + 15;
                max = multiTable[index + 1].startTime;
            }
        } else {
            min = 0;
            max = 1439;
        }

        if ((window.innerWidth <= 960) && (min >= 0 && max >= 0)) {
            this.showHideBg();

            if (index >= 0) multiTable[index].position = position;

            for (const element of multiTable) {
                element.range = [];
            }

            multiTable[index].active = 0;
            multiTable[index].range.push(min);

            for (let i = min; i <= max; i++) {
                if (multiTable[index].range[count] !== (this.quarterTime(i))) {
                    multiTable[index].range.push(i);
                    if (multiTable[index].position == 'start') {
                        if (this.quarterTime(multiTable[index].startTime) == i) {
                            multiTable[index].active = i;
                        }
                    } else {
                        if (this.quarterTime(multiTable[index].endTime) == i) {
                            multiTable[index].active = i;
                        }
                    }
                    count++;
                }
            }

            this.multiTable = multiTable;
            this.setScroll(index);
        }
    }

    private setScroll(index: number): void {
        setTimeout(() => {
            const scroll = this.document.querySelectorAll('.multi__time-list');
            const multiTable = _.cloneDeep(this.multiTable);
            let count = multiTable[index].range.indexOf(this.quarterTime(multiTable[index].active));

            if (count < 0) {
                count = multiTable[index].range.indexOf(this.quarterTime(multiTable[index].active));
            }
            if (count < 0 && index < (multiTable.length - 1)) {
                count = multiTable[index + 1].range.indexOf(this.quarterTime(multiTable[index + 1].active));
            }
            if (count < 0 && index > 0) {
                count = multiTable[index - 1].range.indexOf(this.quarterTime(multiTable[index - 1].active));
            }
            scroll[0].scrollTop = count * 39 - 90;
        }, 0);
    }

    setNonAdjacentIntervals(index: number, value: number, type: number): void {
        const multiTable = _.cloneDeep(this.multiTable);
        multiTable[index].active = value;

        setTimeout(() => {
            if (multiTable[index].position == 'start') {
                multiTable[index].startTime = value;
            } else {
                multiTable[index].endTime = value;
            }
            if (type == 29) {
                if (multiTable[index].position == 'start') {
                    if (multiTable[index].startTime >= multiTable[index].endTime) {
                        multiTable[index].endTime = multiTable[index].startTime
                        if (multiTable[index].endTime >= multiTable[index + 1].startTime) {
                            for (let j = index; j < multiTable.length - 1; j++) {
                                if (multiTable[j].endTime > multiTable[j + 1].startTime) {
                                    multiTable[j + 1].startTime = multiTable[j].endTime
                                }
                                if (multiTable[j + 1].endTime < multiTable[j + 1].startTime) {
                                    multiTable[j + 1].endTime = multiTable[j + 1].startTime;
                                }
                            }
                        }
                    }
                    if (multiTable[index].startTime < multiTable[index - 1].endTime) {
                        multiTable[index - 1].endTime = multiTable[index].startTime;
                        for (let j = index; j >= 0; j--) {
                            if (multiTable[j].startTime <= multiTable[j - 1].endTime) {
                                multiTable[j - 1].endTime = multiTable[index].startTime;
                            }
                            if (multiTable[j - 1].startTime >= multiTable[j - 1].endTime) {
                                multiTable[j - 1].startTime = multiTable[j - 1].endTime
                            }
                        }
                    }
                } else {
                    if (multiTable[index].endTime <= multiTable[index].startTime) {
                        multiTable[index].startTime = multiTable[index].endTime
                        for (let j = index; j >= 0; j--) {
                            if (multiTable[j].startTime <= multiTable[j - 1].endTime) {
                                multiTable[j - 1].endTime = multiTable[index].startTime;
                            }
                            if (multiTable[j - 1].startTime >= multiTable[j - 1].endTime) {
                                multiTable[j - 1].startTime = multiTable[j - 1].endTime
                            }

                        }
                    }
                    if (multiTable[index].endTime >= multiTable[index + 1].startTime) {
                        multiTable[index + 1].startTime = multiTable[index].endTime;
                        for (let j = index; j < multiTable.length - 1; j++) {
                            multiTable[j + 1].startTime = multiTable[j].endTime;
                            if (multiTable[j + 1].startTime >= multiTable[j + 1].endTime) {
                                multiTable[j + 1].endTime = multiTable[j + 1].startTime
                            }
                        }
                    }
                }
            }
            multiTable[index].range = [];
            this.multiTable = multiTable;
            this.showHideBg();
        }, 200);
    }

    setAdjacentIntervals(index: number, value: number): void {
        const multiTable = _.cloneDeep(this.multiTable);
        multiTable[index].active = value;

        setTimeout(() => {
            if (multiTable[index].position === 'start') {
                multiTable[index].startTime = value;
                if (index > 0) {
                    multiTable[index - 1].endTime = value;
                }
            } else {
                multiTable[index].endTime = value;
                if (index < multiTable.length - 1) {
                    multiTable[index + 1].startTime = value;
                }
            }

            multiTable[index].range = [];
            this.multiTable = multiTable;
            this.showHideBg();
            this.multTableChanged.next(true);
        }, 200);
    }

    changeRange(): boolean {
        this.tempDelta = 0;
        return true;
    }

    private quarterTime(val: number): number {
        if (val === 1439) {
            return val;
        } else if (val >= 1424) {
            return 1425;
        }
        return val - val % 15;
    }

    showMultiTempRange(idx: number): void {
        this.tempRange = true;
        this.bgActive = true;
        this.multiTable[idx].isVisible = true;
    }

    private clearMultiTempRange(): void {
        for (const element of this.multiTable) {
            element.range = [];
        }
    }

    smallRangePlusVal(val: string, max: number, value: number){
        return parseInt(val) < max ? parseInt(val) + value : val;
    };

    smallRangeMinusVal(val: string, min: number, value: number){
        return parseInt(val) > min ? parseInt(val) - value : val;
    }

    swipeRange(deltaX: number, index: number, position: 'start' | 'end') {
        const multiTable = _.cloneDeep(this.multiTable);
        let min: number;
        let max: number;
        let swipe = deltaX - this.tempDelta;
        this.tempDelta = deltaX;
        multiTable[index].range = [];

        if (!(index == 0 && position == 'start' || index == (multiTable.length - 1) && position == 'end')) {
            if (position == 'start') {
                min = multiTable[index - 1].startTime;
                max = multiTable[index].endTime;

                if (index === multiTable.length - 1) {
                    max = 1440;
                }

                if (swipe > 0) {
                    multiTable[index].startTime = multiTable[index].startTime + swipe * 3 < max - 15
                        ? multiTable[index].startTime + swipe * 3
                        : max - 15;
                } else {
                    multiTable[index].startTime = multiTable[index].startTime + swipe * 3 > min + 15
                        ? multiTable[index].startTime + swipe * 3
                        : min + 15;
                }

                multiTable[index - 1].endTime = multiTable[index].startTime;
            } else {
                min = multiTable[index].startTime;
                max = multiTable[index + 1].endTime;

                if (index === multiTable.length - 2) {
                    max = 1440;
                }

                if (swipe > 0) {
                    multiTable[index].endTime = multiTable[index].endTime + swipe * 3 < max - 15
                        ? multiTable[index].endTime + swipe * 3
                        : max - 15;
                } else {
                    multiTable[index].endTime = multiTable[index].endTime + swipe * 3 > min + 15
                        ? multiTable[index].endTime + swipe * 3
                        : min + 15;
                }
                multiTable[index + 1].startTime = multiTable[index].endTime;
            }
        }

        this.multiTable = multiTable;
    }

    rangeNonAdjacentInterval(deltaX: number, index: number, position: 'start' | 'end'): void {
        const multiTable = _.cloneDeep(this.multiTable);

        let swipe = (deltaX - this.tempDelta) * 3;
        const swipeRightWithStep = swipe + 15;
        const swipeLeftWithStep = swipe - 15;

        this.tempDelta = deltaX;
        multiTable[index].range = [];

        if (!(index === 0 && position === 'start' || index === (multiTable.length - 1) && position === 'end')) {
            if (position === 'start') {
                this.setStartSlider(multiTable, index, swipe, swipeLeftWithStep, swipeRightWithStep);
            } else {
                this.setEndSlider(multiTable, index, swipe, swipeLeftWithStep, swipeRightWithStep)
            }
        } else if (index === 0 && position === 'start') {
            this.setFirstSlider(multiTable, index, swipe, swipeRightWithStep);
        } else if ((index === multiTable.length - 1) && position === 'end') {
            this.setLastSlider(multiTable, index, swipe, swipeLeftWithStep);
        }

        this.multiTable = multiTable;
    }

    private setStartSlider(multiTable: ScheduleMulti[], index: number, swipe: number, swipeLeftWithStep: number, swipeRightWithStep: number): void {
        if (swipe > 0) {
            if (multiTable[index].endTime + swipeRightWithStep < 1439 - (15 * (multiTable.length - index - 3))) {
                if (multiTable[index].startTime + swipeRightWithStep > multiTable[index].endTime) {
                    multiTable[index].endTime = multiTable[index].startTime + swipeRightWithStep;
                    if (multiTable[index].endTime > 1439) {
                        multiTable[index].endTime = 1439;
                    }
                }

                if (index < multiTable.length - 1) {
                    this.setNextSliders(multiTable, index);
                }

                multiTable[index].startTime = multiTable[index].startTime + swipe;

                if (index === multiTable.length - 1 && multiTable[index].startTime > 1439 - 15) {
                    multiTable[index].startTime = 1440 - 15;
                }
            }
        } else {
            if (multiTable[index].startTime + swipeLeftWithStep > 15 * (index - 1)) {
                multiTable[index].startTime = multiTable[index].startTime + swipe;
            }

            this.setPrevSliders(multiTable, index);
        }
    }

    private setEndSlider(multiTable: ScheduleMulti[], index: number, swipe: number, swipeLeftWithStep: number, swipeRightWithStep: number): void {
        if (swipe > 0) {
            if (multiTable[index].endTime + swipeRightWithStep < 1439 - (15 * (multiTable.length - index - 3))) {
                multiTable[index].endTime = multiTable[index].endTime + swipe;

                this.setNextSliders(multiTable, index);
            }
        } else {
            if (multiTable[index].endTime + swipeLeftWithStep >= 15 * (index)) {
                if (multiTable[index].endTime + swipeLeftWithStep <= multiTable[index].startTime) {
                    multiTable[index].startTime = multiTable[index].endTime + swipeLeftWithStep;
                }

                if (index > 0) {
                    this.setPrevSliders(multiTable, index);
                }

                multiTable[index].endTime = multiTable[index].endTime + swipe;
            }
        }
    }

    private setNextSliders(multiTable: ScheduleMulti[], index: number) {
        if (multiTable[index].endTime >= multiTable[index + 1].startTime) {
            for (let i = index; i < multiTable.length - 1; i++) {
                if (multiTable[i].endTime >= multiTable[i + 1].startTime) {
                    multiTable[i + 1].startTime = multiTable[i].endTime;

                    if (multiTable[i + 1].startTime + 15 > multiTable[i + 1].endTime) {
                        multiTable[i + 1].endTime = multiTable[i + 1].startTime + 15;

                        if (multiTable[i + 1].endTime > 1439) {
                            multiTable[i + 1].endTime = 1439;
                        }
                    }
                }
            }
        }
    }

    private setPrevSliders(multiTable: ScheduleMulti[], index: number): void {
        if (multiTable[index].startTime < multiTable[index - 1].endTime) {
            for (let i = index; i > 0; i--) {
                if (multiTable[i].startTime < multiTable[i - 1].endTime) {

                    multiTable[i - 1].endTime = multiTable[i].startTime;

                    if (multiTable[i - 1].startTime + 15 > multiTable[i - 1].endTime) {
                        multiTable[i - 1].startTime = multiTable[i - 1].endTime - 15;

                        if (multiTable[i - 1].startTime < 0) {
                            multiTable[i - 1].startTime = 0;
                        }
                    }
                }
            }
        }
    }

    private setFirstSlider(multiTable: ScheduleMulti[], index: number, swipe: number, swipeRightWithStep: number): void {
        if (swipe > 0) {
            if (multiTable[index].startTime + swipeRightWithStep > multiTable[index].endTime
                && multiTable[index].startTime + swipeRightWithStep < 1439 - (15 * (multiTable.length - 2))) {
                multiTable[index].endTime = multiTable[index].startTime + swipeRightWithStep;
            }

            this.setNextSliders(multiTable, index);

            if (multiTable[index].startTime + swipeRightWithStep < 1439 - (15 * (multiTable.length - 2))) {
                multiTable[index].startTime = multiTable[index].startTime + swipe;
            }
        } else {
            multiTable[index].startTime = multiTable[index].startTime + swipe;

            if (multiTable[index].startTime <= 0) {
                multiTable[index].startTime = 0;
            }
        }
    }

    private setLastSlider(multiTable: ScheduleMulti[], index: number, swipe: number, swipeLeftWithStep: number): void {
        if (swipe > 0) {
            multiTable[index].endTime = multiTable[index].endTime + swipe;
            if (multiTable[index].endTime >= 1439) {
                multiTable[index].endTime = 1439;
            }
        } else {
            if (multiTable[index].endTime + swipeLeftWithStep < multiTable[index].startTime
                && multiTable[index].endTime + swipeLeftWithStep > 15 * (multiTable.length - 1)) {
                multiTable[index].startTime = multiTable[index].endTime + swipeLeftWithStep;
            }

            this.setPrevSliders(multiTable, index);

            if (multiTable[index].endTime + swipeLeftWithStep > 15 * (multiTable.length - 1)) {
                multiTable[index].endTime = multiTable[index].endTime + swipe;
            }
        }
    }

    multiTableSetDefault(): void {
        this.checkBrotherElement();

        this.multiTable.forEach((val) => {
            val.valueFirstColumn = val.defaultFirstColumn;
            val.valueSecondColumn = val.defaultSecondColumn;
            val.startTime = val.defaultStartTime;
            val.endTime = val.defaultEndTime;
        });

        this.checkScheduleIntervals();
    }

    private validateMultiTable() {
        let isValid = true;

        for (let index = 0; index <= this.multiTable.length - 1; index++) {
            if (index === 0 && this.multiTable[index].startTime !== 0) {
                isValid = false;
            }
            if ((index > 0 && index <= this.multiTable.length) &&
                (this.multiTable[index].startTime !== this.multiTable[index - 1].endTime)) {
                isValid = false;
            }
            if ((index >= 0 && index < this.multiTable.length - 1) &&
                (this.multiTable[index].endTime !== this.multiTable[index + 1].startTime)) {
                isValid = false;
            }
            if (index === this.multiTable.length - 1 && this.multiTable[index].endTime !== 1439) {
                isValid = false;
            }
        }

        return isValid;
    }

    returnMultiTableOnOff(): void {
        const paramsData: ScheduleRange[] = [];
        const params: number[] = [];

        if (this.control.brotherElement) {
            this.tmpBrotherElement = _.cloneDeep(this.control.brotherElement);
        }
        const elementVal = this.control.elementVal.getValue() as MenuElementType100;
        if (elementVal.params.type === 0) {
            const isValid = this.validateMultiTable();
            if (!isValid) {
                this.appAlert.showAppAlert(this.subtitles.setSubtitle(5354),
                    this.subtitles.setSubtitle(1136), null, false, null);
                return;
            }
        }

        for (const element of this.multiTable) {
            const scheduleRange: ScheduleRange = {
                start: 0,
                end: 0,
                interval: 0,
            };

            params.push(this.quarterTime(element.startTime));
            scheduleRange.start = this.quarterTime(element.startTime);

            if (element.endTime < 1439) {
                params.push(this.quarterTime(element.endTime));
                scheduleRange.end = this.quarterTime(element.endTime);
            } else {
                params.push(element.endTime);
                scheduleRange.end = this.quarterTime(element.endTime);
            }

            params.push(element.valueFirstColumn);
            scheduleRange.interval = element.valueFirstColumn;

            paramsData.push(scheduleRange);
        }

        this.sendScheduleData(paramsData);
        this.setNewParams(params, paramsData);
    }

    returnMultiTable(): void {
        const paramsData: ScheduleRange[] = [];
        const params: number[] = [];

        if (this.control.brotherElement) {
            this.tmpBrotherElement = _.cloneDeep(this.control.brotherElement);
        }

        for (const element of this.multiTable) {
            const scheduleRange: ScheduleRange = {
                start: 0,
                end: 0,
                interval: 0,
                temp: 0,
            };

            params.push(this.quarterTime(element.startTime));
            scheduleRange.start = this.quarterTime(element.startTime);

            if (element.endTime < 1439) {
                params.push(this.quarterTime(element.endTime));
                scheduleRange.end = this.quarterTime(element.endTime)
            } else {
                params.push(element.endTime);
                scheduleRange.end = element.endTime
            }

            params.push(element.valueFirstColumn);
            scheduleRange.interval = element.valueFirstColumn;

            params.push(element.valueSecondColumn);
            scheduleRange.temp = element.valueSecondColumn;

            paramsData.push(scheduleRange);
        }

        this.sendScheduleData(paramsData);
        this.setNewParams(params, paramsData);
    }

    private sendScheduleData(paramsData: ScheduleRange[]): void {
        const scheduleData = [];

        if (this.control.brotherElement
            && Array.isArray(this.control.brotherElement)
            && this.control.brotherElement.length > 0) {
            let count = 0;

            for (const element of this.control.brotherElement as MenuElementType100[]) {
                if (element.checked) {
                    const elementVal = this.control.elementVal.getValue() as MenuElementType100;
                    element.params.rows = elementVal.params.rows;
                    element.duringChange = 't';

                    scheduleData[count] = {
                        ido: element.id,
                        paramsData,
                        menuType: element.menuType
                    };
                    count++;
                }
            }
        } else {
            scheduleData.push({
                ido: this.control.elementVal.getValue().id,
                paramsData,
                menuType: this.control.elementVal.getValue().menuType,
            });
        }

        scheduleData.forEach(({ menuType, ido, paramsData }) => {
            const dataToSend = {
                menuType,
                ido,
                data: {
                    universal_schedule: paramsData,
                }
            }
            if (this.control.pin) {
                dataToSend.data['pin'] = this.control.pin;
            }
            this.sendData.sendControlData(dataToSend);
        });

        if (this.control.pin) {
            this.control.pin = ''
        }
    }

    private setNewParams(params: number[], paramsData: ScheduleRange[]): void {
        if (!this.parameters.demoAccount()) {
            const element = this.control.element.getValue() as MenuElementType100;
            element.params.value = params;
            element.params.rows.forEach((row: ScheduleMulti, idx: number) => {
                row.startTime = paramsData[idx].start;
                row.endTime = paramsData[idx].end;
                row.valueFirstColumn = paramsData[idx].interval;
                if (paramsData[idx].temp !== undefined) {
                    row.valueSecondColumn = paramsData[idx].temp
                }
            });
            element.duringChange = 't';
            this.control.element.next(element);

            this.control.setsNewValue = this.control.elementVal.getValue().id;
            this.control.hideControl();
        } else {
            if (this.control.brotherElement
                && Array.isArray(this.control.brotherElement)) {
                this.control.brotherElement.forEach((val, key) => {
                    val.params = this.tmpBrotherElement[key].params;
                    val.duringChange = this.tmpBrotherElement[key].duringChange;
                });
            }
        }
    }
}
